import { useContext } from "react";
import StreamsContext from "contexts/StreamsContext";
const useHasAccessToAnyStream = () => {
  const streams = useContext(StreamsContext);
  return !!streams && streams.length > 0;
};
export default useHasAccessToAnyStream;
